import { inject, Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { TasksService } from "src/app/services/tasks.service";

@Injectable()
export class UserReadyGuard implements CanActivate {
  readonly #tasksService = inject(TasksService);

  async canActivate(): Promise<boolean> {
    setTimeout(() => {
      this.#tasksService.userReady();
    }, 1000);

    return true;
  }
}
